import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {setPromptVariable} from "@khan/guide-core-helpers";

import type {
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ExerciseDetailsType,
    getPrerequisiteExercisesType,
} from "./__graphql-types__/index.ts";
import {unsetSharedDetails} from "./shared-details.ts";

export const CONTENT_GET_PREREQUISITE_EXERCISES: GqlOperation<
    getPrerequisiteExercisesType["response"],
    getPrerequisiteExercisesType["variables"]
> = gqlOp(gql`
    query getPrerequisiteExercises($slugs: [String!]!) {
        exercisesBySlugs(slugs: $slugs) {
            id
            slug
            translatedTitle
            translatedDescription
            mappedStandards {
                id
                standardId
            }
        }
    }
`);

export const EXERCISE_DETAILS_QUERY: GqlOperation<
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ExerciseDetailsType["response"],
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ExerciseDetailsType["variables"]
> = gqlOp(gql`
    query AITeacherTools_ExerciseDetails($exerciseId: String!) {
        exerciseById(id: $exerciseId) {
            id
            translatedTitle
            prerequisites
            defaultUrlPath
            parentTopic {
                id
                domainSlug
                allLearnableContent(includeUnlisted: false) {
                    id
                    translatedTitle
                    defaultUrlPath
                }
            }
            assessmentItems {
                id
                itemShapeType
                itemData
                problemType
            }
        }
    }
`);

export function unloadExerciseDetails() {
    [
        "contentTitle",
        "context",
        "correctanswer",
        "domain",
        "questionBankFull",
        "questionBankOnePerType",
        "questionBankFirstItem",
        "answerBankFull",
        "answerBankOnePerType",
        "hintsBankFull",
        "hintsBankOnePerType",
        "prerequisiteSlugs",
        "prerequisiteDetails",
    ].forEach((variable) => {
        setPromptVariable(variable, null);
    });
    unsetSharedDetails();
}
